/* eslint-disable react-hooks/exhaustive-deps */
import classNames from "classnames";
import { useCallback, useEffect, useRef } from "react";
import { thirdLogin, getMe } from "../../../services";
import HBIcon from "../../HBIcon";
import styles from "../index.module.less";

const isClient = typeof window !== "undefined";
/**
 * 第三方登录
 */
export default function Third({ isRegister, onOk }) {
  return (
    <div className={styles.other}>
      <div className={styles.desc}>其他方式{isRegister ? "注册" : "登录"}</div>
      <ThirdLogin onOk={onOk} />
    </div>
  );
}

export function ThirdLogin({ onOk }) {
  const dataRef = useRef({});
  const loginCb = useCallback(async (e) => {
    if (e.key && e.key == "third_login") {
      if (e.newValue === "ok" || e.newValue === "register_ok") {
        // 关闭第三方登录窗口
        window.__login_window.close();
        const result = await getMe();
        onOk &&
          onOk({
            user: result,
            loginType: dataRef.current.type,
            isRegister: e.newValue === "register_ok",
          });

        window.removeEventListener("storage", loginCb);
      }
    }
  }, []);

  const login = useCallback((type) => {
    thirdLogin(type);
    dataRef.current.type = type;
    // 监听第三方登录状态的变化
    window.addEventListener("storage", loginCb);

    // 20分钟后自动取消监听
    // setTimeout(() => {
    //   window.removeEventListener('storage', loginCb);
    // }, 20*60*1000);
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("storage", loginCb);
    };
  }, []);

  return (
    <div className={styles.thirdLoginList}>
      {/* <div
        className={classNames([styles.thirdLoginItem, styles.wechat])}
        data-gd-click="button_click"
        data-button-name="微信登录注册"
        onClick={() => {
          login("wechat");
        }}
      >
        <HBIcon className={styles.icon} type="ic_wechat1" title="微信" />
      </div> */}
      <div
        className={classNames([styles.thirdLoginItem, styles.qq])}
        data-gd-click="button_click"
        data-button-name="QQ登录注册"
        onClick={() => {
          login("qzone");
        }}
      >
        <HBIcon className={styles.icon} type="ic_qq1" title="QQ" />
      </div>
      <div
        className={classNames([styles.thirdLoginItem, styles.weibo])}
        data-gd-click="button_click"
        data-button-name="微博登录注册"
        onClick={() => {
          login("weibo");
        }}
      >
        <HBIcon className={styles.icon} type="ic_xl1" title="微博" />
      </div>
      <div
        className={classNames([styles.thirdLoginItem, styles.douban])}
        data-gd-click="button_click"
        data-button-name="豆瓣登录注册"
        onClick={() => {
          login("douban");
        }}
      >
        <HBIcon className={styles.icon} type="ic_db" title="豆瓣" />
      </div>
    </div>
  );
}

export function thirdLoginOK() {
  // 第三方登录过来的改变登录状态
  if (isClient && localStorage.getItem("third_login") === "loading") {
    localStorage.setItem("third_login", "ok");
    return true;
  }
  return false;
}

export function thirdLoginLoading() {
  if (isClient) {
    // 改变状态
    localStorage.setItem("third_login", "loading");
  }
}

export function thirdLoginRegisterOk() {
  if (isClient) {
    // 改变状态
    localStorage.setItem("third_login", "register_ok");
  }
}
